module.exports = __webpack_public_path__ + "img/bg_front.a67faf4c.png";